import httpClient from './httpClient'

const END_POINT = '/account'

const loginTenant = data => httpClient.post('/account/logintenant', data)
const pickTenant = data => httpClient.post('/account/picktenant', data)
const localLogin = data => httpClient.post('/account/locallogin', data)
const generateUserLoginKey = data => httpClient.post('/account/generateuserloginkey', data)
const changeTenant = data => httpClient.post('/account/changeTenant', data)

export { loginTenant, pickTenant, localLogin, generateUserLoginKey,changeTenant}
